export const frequencyMap = [
  {
    label: 'frequencyMap.none',
    value: 'None',
  },
  // {
  //   label: 'frequencyMap.daily',
  //   value: 'Daily',
  // },
  // {
  //   label: 'frequencyMap.weekly',
  //   value: 'Weekly',
  // },
   {
    label: 'frequencyMap.quarterly',
    value: 'Quarterly',
  },
  {
    label: 'frequencyMap.monthly',
    value: 'Monthly',
  },
];

export const complianceLevelMap = [
  {
    label: 'AAA',
    value: 'AAA',
  },
  {
    label: 'AA',
    value: 'AA',
  },
  {
    label: 'A',
    value: 'A',
  },
];

export const auditEngineMap = [
  {
    label: 'IA Labs Engine',
    value: 'IA Labs Engine',
  },
];
